import { AttrKeys } from '@sharedModule/constants/fields.constant';

export const ADAPTER_SETTINGS_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  adapter: {
    type: 'text',
    key: 'adapter',
    label: 'Adapter',
  },
  adapterType: {
    type: 'text',
    key: 'adapter_type',
    label: 'Adapter Type',
  },
  description: {
    type: 'text',
    key: 'description',
    label: 'Description',
  },
  dataType: {
    type: 'text',
    key: 'data_type',
    label: 'Data Type',
  },
  name: {
    type: 'text',
    key: 'name',
    label: 'Name',
  },
  code: {
    type: 'select',
    key: 'code',
    label: 'Adapter',
  },
} as const;

export const ADAPTER_SETTINGS_MESSAGE_CONSTANT = {
  [ADAPTER_SETTINGS_ATTRIBUTES_CONSTANT.name.key as AttrKeys]: {
    pattern: 'Only alphabets and integers are allowed',
    confirmPasswordValidator: '',
  },
};

export const DATA_TYPE = [
  {
    name: 'Email',
    value: 'email',
  },
  {
    name: 'Password',
    value: 'password',
  },
  {
    name: 'Text',
    value: 'text',
  },
  {
    name: 'Number',
    value: 'number',
  },
  {
    name: 'Boolean',
    value: 'boolean',
  },
  {
    name: 'JSONB',
    value: 'jsonb',
  },
];
